import passwordDictionary from '@features/create-password/i18n/ru/create-password.dic.json';

export const password = {
  PASSWORD: passwordDictionary,
};

export const passwordNamespaces = ['PASSWORD'];
